<vectronic-card [title]="'Create Group'" [displayClose]="true" (closed)="cancel()">
  <ng-container body [formGroup]="createGroupForm">
    <mat-dialog-content class="dialog-body create-group">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Personal Notes</mat-label>
        <input matInput formControlName="label" />
        <mat-hint>Only visible to you</mat-hint>
      </mat-form-field>
      <mat-form-field class="description" appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput formControlName="description" />
      </mat-form-field>
      <h2 class="member-selection-text">Items in Group:</h2>
      <mat-selection-list class="member-selection__list" formControlName="selectedItemsIds">
        @for (item of filteredItems(); track item) {
          <mat-list-option class="member-selection__item" [value]="item.id">
            {{ item.name }}
          </mat-list-option>
        }
      </mat-selection-list>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-button-container">
      <button
        mat-button
        color="warn"
        type="reset"
        class="modal-button-container__cancel-button"
        (click)="cancel()"
      >
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>

      <button
        mat-button
        color="accent"
        type="submit"
        class="modal-button-container__apply-button"
        (click)="apply()"
      >
        <mat-icon>check_circle</mat-icon>
        Apply
      </button>
    </mat-dialog-actions>
  </ng-container>
</vectronic-card>
